import { render, staticRenderFns } from "./AgentResult.vue?vue&type=template&id=4c80f849"
import script from "./AgentResult.vue?vue&type=script&lang=js"
export * from "./AgentResult.vue?vue&type=script&lang=js"
import style0 from "./AgentResult.vue?vue&type=style&index=0&id=4c80f849&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports